import { useEffect } from 'react';
import useDailyChecklistDraft from './useDailyChecklistDraft';

// Bundles the plumbing every checklist section repeats around
// useDailyChecklistDraft: the draft hook itself, folding `hasServerAction`
// into an effective `completed` (a section counts as done once a matching
// SupervisorAction exists on the server, even without a local commit), and
// notifying the parent whenever that effective state changes.
//
// Shared by LineHaulSection, HeadcountSection, and MissedStopsReviewSection.
// Mark-Complete gating stays in each section — it derives from
// section-specific field rules, not from draft state.
export default function useChecklistSection({
  sectionId,
  stockingDate,
  initialFields,
  serverFields,
  hasServerAction = false,
  onCompletedChange = () => {},
}) {
  const draft = useDailyChecklistDraft({
    sectionId,
    stockingDate,
    initialFields,
    serverFields,
  });

  const completed = draft.completed || hasServerAction;

  useEffect(() => {
    onCompletedChange(completed);
  }, [completed, onCompletedChange]);

  return {
    fields: draft.fields,
    setField: draft.setField,
    markComplete: draft.markComplete,
    cancel: draft.cancel,
    loaded: draft.loaded,
    completed,
  };
}
